import { render } from "./payroll.vue?vue&type=template&id=2da9550c"
import script from "./payroll.vue?vue&type=script&lang=js"
export * from "./payroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__